import {
    FETCH_PRODUCTS,
    FETCH_CATEGORIES,
    DOWNLOAD_PRODUCTS_EXCEL, EAGER_FETCH_PRODUCTS, RESET_PRODUCTS
} from "./actions.type";
import {
    CATEGORIES_FETCHED,
    CATEGORY_CHANGED,
    PRODUCTS_FETCH_START,
    PRODUCTS_FETCH_END,
    NO_RESPONSE_ERROR,
    FILE_DOWNLOADED, EAGER_PRODUCTS_FETCH_END
} from "./mutations.type";
import { ParametricSearchService } from "@/common/api.service";
import { downloadFile, mimeTypes } from "@/common/download.service";

export function getInitialState() {
    return {
        eagerProductData: {
            products: [],
            headlines: [],
            facets: [],
            demoBoardFacets: [],
            targetApplications: [],
            success: false,
            validResponse: false,
        },
        products: [],
        isParametricSearchLoading: true,
        columns: [],
        facets: [],
        demoBoardFacets: [],
        targetApplications: [],
        success: false,
        validResponse: true,
    }
}

const state = getInitialState();

const getters = {
    columns(state) {
        return state.columns;
    },
    products(state) {
        return state.products;
    },
    facets(state) {
        return state.facets;
    },
    demoBoardFacets(state){
        return state.demoBoardFacets;
    },
    columnNumber(state){
        return state.columnNumber;
    },
    isParametricSearchLoading(state) {
        return state.isParametricSearchLoading;
    },
    isSuccess(state){
        return state.success;
    },
    targetApplications(state){
        return state.targetApplications;
    },
    targetFrequencies(state){
        return state.targetFrequencies;
    },
    validResponse(state){
        return state.validResponse;
    },
};

const actions = {
    [FETCH_CATEGORIES]({commit}, params) {
        return ParametricSearchService.getCategories(params)
            .then(response => {
                commit(CATEGORIES_FETCHED, response);
                commit(CATEGORY_CHANGED, null)
            })
            .catch(error => {
                throw new Error(error);
            });
    },

    [FETCH_PRODUCTS]({commit}, params) {
        commit(PRODUCTS_FETCH_START);
        return ParametricSearchService.query(params)
            .then(({data}) => {
                commit(PRODUCTS_FETCH_END, data);
            })
            .catch(error => {
                commit(NO_RESPONSE_ERROR);
                throw new Error(error);
            });
    },

    [RESET_PRODUCTS]({commit, state}) {
        commit(PRODUCTS_FETCH_END, state.eagerProductData);
    },

    [EAGER_FETCH_PRODUCTS]({commit}, params) {
        return ParametricSearchService.query(params)
            .then(({data}) => {
                commit(EAGER_PRODUCTS_FETCH_END, data);
            })
            .catch(error => {
                commit(NO_RESPONSE_ERROR);
                throw new Error(error);
            });
    },

    [DOWNLOAD_PRODUCTS_EXCEL]({commit}, params) {
        commit(PRODUCTS_FETCH_START);
        return ParametricSearchService.downloadExcel(params)
            .then(function(response) {
                downloadFile(response, mimeTypes.xlsx);
                commit(FILE_DOWNLOADED);
            })
            .catch(error => {
                commit(NO_RESPONSE_ERROR);
                throw new Error(error);
            });
    },

};

const mutations = {
    [CATEGORIES_FETCHED](state, response) {
        state.categories = response.data;
    },
    [PRODUCTS_FETCH_START](state) {
        state.isParametricSearchLoading = true;
    },
    [PRODUCTS_FETCH_END](state, data) {
        state.success = data.success;
        if(state.success) {
            state.columns = data.headlines;
            state.products = data.products;
            state.facets = data.facets;
            state.demoBoardFacets = data
                .demoBoardFacets
                .filter(facet => facet != null);
            state.targetApplications = data.targetApplications;
            state.targetFrequencies = data.targetFrequencies;
            state.validResponse = true;
        }
        state.isParametricSearchLoading = false;
    },

    [EAGER_PRODUCTS_FETCH_END](state, data) {
        state.eagerProductData.success = data.success;
        if(state.eagerProductData.success) {
            state.eagerProductData.headlines = data.headlines;
            state.eagerProductData.products = data.products;
            state.eagerProductData.facets = data.facets;
            state.eagerProductData.demoBoardFacets = data.demoBoardFacets.filter(facet => facet != null);
            state.eagerProductData.targetApplications = data.targetApplications;
            state.eagerProductData.validResponse = true;
        }
        state.isParametricSearchLoading = false;
    },

    [NO_RESPONSE_ERROR](){
        state.isParametricSearchLoading = false;
        state.success = true;
        state.products = [];
        state.facets = [];
        state.demoBoardFacets = [];
        state.validResponse = false;
    },
    [FILE_DOWNLOADED] (){
        state.success = true;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
